import { size } from "lodash";
import { AttachmentType } from "components/chat/ChatRoom/ChatMessage";

export function createAttachmentQuoteText({
  files,
  images,
}: {
  files?: AttachmentType[];
  images?: AttachmentType[];
}) {
  const fileCount = size(files || []);
  const imageCount = size(images || []);

  if (fileCount === 0 && imageCount === 0) {
    return null;
  }

  const params = {
    count: 0,
    files_count: 0,
    images_count: 0,
  };

  let i18nKey = "js.chat.quote.attachments.";

  if (fileCount > 0 && imageCount > 0) {
    // files and images
    if (fileCount === 1 && imageCount === 1) {
      i18nKey += "one_file_one_image";
    } else if (fileCount === 1 && imageCount > 1) {
      i18nKey += "one_file_multiple_images";
      params.count = imageCount;
    } else if (fileCount > 1 && imageCount === 1) {
      i18nKey += "multiple_files_one_image";
      params.count = fileCount;
    } else {
      i18nKey += "multiple_files_multiple_images";
      params.files_count = fileCount;
      params.images_count = imageCount;
    }
  } else if (fileCount > 0) {
    // only files
    if (fileCount === 1) {
      i18nKey += "one_file";
    } else {
      i18nKey += "multiple_files";
      params.count = fileCount;
    }
  } else if (imageCount > 0) {
    // only images
    if (imageCount === 1) {
      i18nKey += "one_image";
    } else {
      i18nKey += "multiple_images";
      params.count = imageCount;
    }
  }

  return I18n.t(i18nKey, params);
}
